import Model from '@/models/BaseModel'
import i18n from '@/plugins/i18n'

export default class LandingPage extends Model {
    resourceName() {
        return 'landing-pages'
    }

    fields() {
        return ['name', 'url']
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.landingPage.attributes.name'),
                value: 'name',
                sortable: false,
            },
            {
                text: i18n.t('resources.landingPage.attributes.url'),
                value: 'url',
                sortable: false,
            },
            {
                text: i18n.t('resources.default.actions'),
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }
}
